/**
 * SideNavLayout Component
 *
 * Two columns — a side nav and its content — that become list → detail screens on mobile.
 */
import * as React from 'react';
import { cn, getTestId } from '../utils';

export type SideNavLayoutView = 'list' | 'detail';

export interface SideNavLayoutProps {
  /** The side column, usually a `SideNav`. */
  nav: React.ReactNode;
  children: React.ReactNode;
  /** Below 768 px only one column shows: `list` the nav, `detail` the content. */
  view: SideNavLayoutView;
  className?: string;
  testId?: string;
  id?: string;
}

export const SideNavLayout = React.forwardRef<HTMLDivElement, SideNavLayoutProps>(
  ({ nav, children, view, className, testId, id }, ref) => (
    <div
      ref={ref}
      id={id}
      data-testid={getTestId({ testId, id })}
      data-view={view}
      className={cn(
        'md:grid md:grid-cols-[232px_minmax(0,1fr)] md:items-start md:gap-lg lg:grid-cols-[264px_minmax(0,1fr)] lg:gap-xl',
        className
      )}
    >
      <div className={cn('min-w-0', view === 'detail' && 'max-md:hidden')}>{nav}</div>
      <div className={cn('min-w-0', view === 'list' && 'max-md:hidden')}>{children}</div>
    </div>
  )
);

SideNavLayout.displayName = 'SideNavLayout';
